// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__-ayPW","description":"PatientConsentPreview_description__3C8FD"};